import type { ReactElement, Ref } from 'react';
import { forwardRef } from 'react';

import type { IIconProps, TIconColor } from './icon.interface';
import * as IconModules from './svg-icon';

const iconColor: TIconColor = {
  primary: 'co-fill-primary-main',
  secondary: 'co-fill-secondary-main',
  success: 'co-fill-success-main',
  warning: 'co-fill-warning-main',
  error: 'co-fill-error-dark co-stroke-error-dark',
  info: 'co-fill-info-dark',
  white: 'co-fill-common-white',
  black: 'co-fill-common-black',
  gray: 'co-fill-gray-main',
  cyanBblue: 'co-fill-[#255aa1]'
};

export const Icon = forwardRef(
  (
    { icon, width = 24, height = 24, color, solid, className }: IIconProps,
    ref: Ref<SVGSVGElement>
  ): ReactElement => {
    const IconToRender = IconModules[icon];
    const createIconColor = (): string => {
      if (color === 'white') return 'co-fill-common-white';
      if (color === 'cyanBlue') return 'co-fill-[#255aa1]';
      if (icon === 'SpinnerIcon') {
        if (color === 'secondary') return 'co-text-secondary-main';
        if (color === 'gray') return 'co-text-gray-main';
        return 'co-text-primary-main';
      }

      return iconColor[color ?? 'primary'];
    };

    return (
      <IconToRender
        solid={solid}
        ref={ref}
        width={width}
        height={height}
        className={className}
        color={createIconColor()}
      />
    );
  }
);
